export type FilterGroup = {
  key: "genres" | "region" | "year";
  label: string;
  options: string[];
  multiple: boolean;
};

export const movieGenres = ["剧情", "悬疑", "犯罪", "动作", "科幻", "爱情", "喜剧", "动画", "奇幻", "冒险", "战争", "治愈"];
export const tvGenres = ["悬疑", "犯罪", "剧情", "都市", "爱情", "科幻", "奇幻", "古装", "青春", "喜剧", "职场", "治愈"];
export const varietyGenres = ["访谈", "文化", "真人秀", "生活", "美食", "竞技", "音乐", "喜剧", "语言", "旅行", "纪实"];

export const regions = ["大陆", "欧美", "日韩", "港台"];

export const yearOptions = ["2025", "2024", "2023", "2022", "更早"];

export const sortOptions = [
  { key: "updated", label: "最新更新" },
  { key: "heat", label: "热度最高" },
  { key: "rating", label: "评分最高" },
] as const;

export type SortKey = (typeof sortOptions)[number]["key"];

export const typeLabels: Record<string, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const typeIntroductions: Record<string, string> = {
  movie: "收录院线佳片、口碑佳作与获奖影片，按类型、地区与年份逐步筛选，找到今晚最适合的那一部。",
  tv: "从刑侦悬疑到都市生活与东方古装，长期更新的剧集档案按集数整理，追更进度一目了然。",
  variety: "访谈、真人秀、美食竞技与音乐纪实，看看屏幕之外真实的人在做什么、说什么。",
};